module.exports = new __parcel__URL__("group-avatar.46fc45c1.svg").toString();